import React from 'react';
import PropTypes from 'prop-types';

import { Add, Remove } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import Box from '@mui/material/Box';

import { BLACK, PRIMARY_COLOR } from '../theme/colorConstants';

const NumberIncrementDecrement = ({
  value,
  onChange,
  min = 0,
  max = 10000,
  disabled = false,
  testId,
  width = '80px',
}) => {
  const handleIncrement = () => {
    const newValue = Math.min(max, (parseInt(value, 10) || 0) + 1);
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max(min, (parseInt(value, 10) || 0) - 1);
    onChange(newValue);
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value === '' ? '' : parseInt(event.target.value, 10);
    if (
      inputValue === '' ||
      (!Number.isNaN(inputValue) && inputValue >= min && inputValue <= max)
    ) {
      onChange(inputValue);
    }
  };

  const isInvalid = value !== '' && (value < min || value > max);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <IconButton
        onClick={handleDecrement}
        disabled={disabled || (parseInt(value, 10) || 0) <= min}
        sx={{
          backgroundColor: PRIMARY_COLOR[70],
          color: 'white',
          width: 32,
          height: 32,
          '&:hover': {
            backgroundColor: PRIMARY_COLOR[80],
          },
          '&:disabled': {
            backgroundColor: BLACK[30],
            color: BLACK[50],
          },
        }}
      >
        <Remove />
      </IconButton>
      <TextField
        type="number"
        sx={{
          width,

          '& input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
          },
        }}
        variant="outlined"
        size="small"
        value={value}
        onChange={handleInputChange}
        error={isInvalid}
        disabled={disabled}
        InputProps={{
          min,
          max,
          'data-testid': testId,
          style: { textAlign: 'center' },
        }}
      />
      <IconButton
        onClick={handleIncrement}
        disabled={disabled || (parseInt(value, 10) || 0) >= max}
        sx={{
          backgroundColor: PRIMARY_COLOR[70],
          color: 'white',
          width: 32,
          height: 32,
          '&:hover': {
            backgroundColor: PRIMARY_COLOR[80],
          },
          '&:disabled': {
            backgroundColor: BLACK[30],
            color: BLACK[50],
          },
        }}
      >
        <Add />
      </IconButton>
    </Box>
  );
};

NumberIncrementDecrement.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  testId: PropTypes.string,
  width: PropTypes.string,
};

export default NumberIncrementDecrement;
